import {
    Container,
    Typography,
    Box,
    Divider,
    Grid,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import MockData from "../../helper/MockData";
import EventList from "../../components/app/EventList";
import EventCard from "../../components/app/EventCard";
import EventDetailCard from "../../components/app/EventDetailCard";

export default function TestEventList() {
    const { t } = useTranslation();

    let lang = getLang();
    let eventList = MockData.getEventList();
    let event = eventList[0];

    return (
        <Container maxWidth="lg">
            <Typography variant="h3">Test EventList</Typography>


            <Grid>
                <EventDetailCard event={event} />
                <EventCard event={event} />
                <Divider sx={{ my: 2 }} />
                <EventList eventList={eventList} />
            </Grid>
        </Container>
    )
}
